module.exports = "https://cdn.hellotech.com/client-assets/tv-mounting-desktop_d8f25185b8c4eb2b6a0abe4ec443a41e.jpg";